import 'css-chunksrc/feature/image/Image.module.scss';export default {
  "root": "Image_root",
  "is_valid": "Image_is_valid",
  "is_loading": "Image_is_loading",
  "loading_icon": "Image_loading_icon",
  "is_error": "Image_is_error",
  "img": "Image_img"
};